import {Component, OnInit} from '@angular/core';
import {PermissionService} from 'src/app/shared/services/permission.service';
import {Permissions} from 'src/app/shared/models/permissions.model';
import { version } from '../../../../package.json';
import {Router} from '@angular/router';
import {RelationshipManager} from '../../shared/models/relationship-manager.model';
import {CompanyService} from '../../shared/services/company.service';

@Component({
  selector: 'main-footer',
  templateUrl: './main-footer.component.html'
})
export class MainFooterComponent implements OnInit {

  public version: string = version;
  relationshipManagers: Array<RelationshipManager>;
  permissions: Permissions;
  canViewLoans = true;
  canViewReports = true;
  canViewMyProfile = true;
  canViewAdmin = true;

  constructor(
    private companyService: CompanyService,
    private permissionsService: PermissionService,
    private router: Router) {
  }

  ngOnInit() {
    this.permissionsService.permissions$.subscribe((permissions: Permissions) => {
      if (permissions) {
        this.permissions = permissions;
        this.canViewLoans = this.permissions.canViewLoans;
        this.canViewReports = this.permissions.canViewReports;
        this.canViewMyProfile = this.permissions.canViewProfile;
        this.canViewAdmin = this.permissions.canViewAdmin;
        this.companyService.getRelationshipManagers().then(
          res => {
            this.relationshipManagers = res;
            console.log(res);
          }
        );
      }
    });
  }

  routeTo(route: string) {
    this.router.navigate([route]);
  }
}
